import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-course-wizard',
  templateUrl: './course-wizard.component.html',
  styleUrls: ['./course-wizard.component.scss']
})
export class CourseWizardComponent implements OnInit {

  public courses: any[] = [];
  public modules: any[] = [];
  public lessons: any[] = [];

  constructor(private toastrService: ToastrService, private router: Router, public courseService: CourseService) { }

  ngOnInit(): void {
    this.courseService.getAllCourses().subscribe(
      (res: any) => {
        this.courses = res;
        if (this.courses.length && !this.courseService.selectedCourse) {
          this.courseService.selectedCourse = this.courses[0]._id;
          this.courseService.courseMode = this.courses[0].mode;
        }
        if (this.courseService.selectedCourse) {
          this.getModules();
        }
      },
      (error) => {
        this.toastrService.error(error?.error?.message);
      }
    );


  }

  getModules() {
    this.courseService.getAllModules().subscribe(
      (res: any) => {
        this.modules = res;
        if (this.modules.length) {
          this.courseService.selectedModule = this.modules[0]._id;
          this.getLessons();
        }
        else {
          this.lessons = [];
        }
      },
      (error) => {
        this.toastrService.error(error?.error?.message);
      }
    )
  }

  getLessons() {
    this.courseService.getAllLessons().subscribe(
      (res: any) => {
        this.lessons = res;
      },
      (error) => {
        this.toastrService.error(error?.error?.message);
      }
    )
  }

  onAddCourse() {
    this.router.navigate(['courses/add']);
  }

  onAddLesson() {
    this.router.navigate(['courses/'+this.courseService.selectedCourse+'/modules/'+this.courseService.selectedModule+'/lessons/add']);
  }

  onAddModule() {
    this.router.navigate(['courses/'+this.courseService.selectedCourse+'/modules/add']);
  }


  onEditCourse(course) {
    this.router.navigate([`courses/${course._id}/modify`]);
  }

  onEditModule(module) {
    this.router.navigate([`courses/${this.courseService.selectedCourse}/modules/${module._id}/modify`]);

  }

  onEditLesson(lesson) {
    this.router.navigate([`courses/${this.courseService.selectedCourse}/modules/${this.courseService.selectedModule}/lessons/${lesson._id}/modify`]);
  }


  onClickCourse(course) {
    if (course._id !== this.courseService.selectedCourse) {
      this.courseService.selectedModule = '';
      this.courseService.selectedLesson = '';
    }
    this.courseService.selectedCourse = course._id;
    this.courseService.courseMode = course.mode;
    this.getModules();
  }

  onClickModule(module) {
    this.courseService.selectedModule = module._id;
    this.getLessons();

  }

  onClickLesson(lesson) {
    this.courseService.selectedLesson = lesson._id;
  }

  publishCourse(){
    this.courseService.publishCourse().subscribe(
      (res)=>{
        this.courseService.courseMode = 'P';
        this.toastrService.success('Course published!');
      },
      (error) => {
        this.toastrService.error(error?.error?.message);
      }
    )
  }

  unPublishCourse(){
    this.courseService.unpublishCourse().subscribe(
      (res:any)=>{
        this.courseService.courseMode = 'D';
        this.toastrService.success('Course unpublished!');
      },
      (error) => {
        this.toastrService.error(error?.error?.message);      
      }
    )
  }

  deleteLesson(lesson) {
    this.courseService.deleteLesson(this.courseService.selectedCourse, this.courseService.selectedModule, lesson._id)
      .subscribe((res: any) => {
        this.toastrService.success(`Lesson ${lesson?.title} deleted`);
        this.getLessons();
      }, error => {
        this.toastrService.error(error?.error?.message);
      })
  }
}
